import { useRef, useState, useEffect } from 'react';

// UI
import { Button } from '@shared/ui';

// Utils
import { combineClasses } from '@shared/utils';

// Icons
import ChevronLeftIcon from '@shared/icons/ChevronLeftIcon';
import ChevronRightIcon from '@shared/icons/ChevronRightIcon';
const SidebarScroll = ({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const checkScrollButtons = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };
  const scroll = (direction: string) => {
    const el = scrollRef.current;
    if (!el) return;
    const scrollAmount = el.clientWidth * 0.8;
    el.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener('scroll', checkScrollButtons);
    checkScrollButtons();
    return () => el.removeEventListener('scroll', checkScrollButtons);
  }, []);
  const handleNext = () => {
    scroll('right');
  };
  const handlePrevious = () => {
    scroll('left');
  };
  return <div className="rounded-xl bg-primary w-full sm:hidden" data-sentry-component="SidebarScroll" data-sentry-source-file="SidebarScroll.tsx">
      <div className="relative gap-1 flex items-center justify-center w-full max-w-full">
        <Button aria-label="Prev nav bar button" onClick={handlePrevious} disabled={!canScrollLeft} className={combineClasses('h-full rounded-s-md min-w-10 px-3 py-2.5 bg-transparent hover:bg-transparent focus:bg-transparent', !canScrollLeft && 'opacity-50 cursor-not-allowed disabled:pointer-events-auto')} data-sentry-element="Button" data-sentry-source-file="SidebarScroll.tsx">
          <ChevronLeftIcon className="size-8" data-sentry-element="ChevronLeftIcon" data-sentry-source-file="SidebarScroll.tsx" />
        </Button>

        <div ref={scrollRef} className={combineClasses('flex overflow-x-auto no-scrollbar scroll-smooth max-w-full gap-2', className)} {...props}>
          {children}
        </div>
        <Button aria-label="Next nav bar button" onClick={handleNext} disabled={!canScrollRight} className={combineClasses('h-full rounded-e-md min-w-10 px-3 py-2.5 bg-transparent hover:bg-transparent focus:bg-transparent', !canScrollRight && 'opacity-50 cursor-not-allowed disabled:pointer-events-auto')} data-sentry-element="Button" data-sentry-source-file="SidebarScroll.tsx">
          <ChevronRightIcon className="size-8" data-sentry-element="ChevronRightIcon" data-sentry-source-file="SidebarScroll.tsx" />
        </Button>
      </div>
    </div>;
};
export default SidebarScroll;